import { ReactElement } from 'react';

export enum UiLanguageEnum {
  ENGLISH = 'en-US',
  GERMAN = 'de-DE',
  SPANISH = 'es-ES',
  PORTUGUESE = 'pt-BR',
  ITALIAN = 'it-IT',
  FRENCH = 'fr-FR',
  JAPANESE = 'ja-JP',
  KOREAN = 'ko-KR',
  DUTCH = 'nl-NL',
  FINNISH = 'fi-FI',
  HUNGARIAN = 'hu-HU',
  POLISH = 'pl-PL',
  SLOVAK = 'sk-SK',
  SWEDISH = 'sv-SE',
}

export type TLanguageSwitcherProps = {
  component?: 'Select' | 'MenuItem';
  onLanguageChange?: (code: UiLanguageEnum) => void;
  compact?: boolean;
};

export type TLanguageOption = {
  code: UiLanguageEnum;
  flag: ReactElement;
  sortLabel: string;
};
